<template>
  <div class="wizard-header">
    <div class="progress-bar" :style="`width: ${(100 / numberOfSteps) * currentStep + 50 / numberOfSteps}%`"></div>
    <ul>
      <li
        v-for="(step, index) in formSteps"
        :key="step.title + index"
        :class="{ checked: step.checked, active: index === currentStep }"
        @click="step.checked && changeStep(index)"
      >
        <div :class="['circle-number', { checked: step.checked, active: index === currentStep }]">
          {{ index + 1 }}
        </div>
        {{ step.title }}
      </li>
    </ul>
  </div>
  <div class="steps">
    <slot></slot>
  </div>
  <div class="wizard-step-button-container">
    <div v-if="currentStep === 0"></div>
    <button v-if="currentStep > 0" class="wizard-step-button" @click="changeStep(currentStep - 1)">Back</button>
    <button v-if="currentStep === numberOfSteps - 1" class="wizard-step-button next" @click="onComplete">Save</button>
    <button v-else class="wizard-step-button next" @click="changeStep(currentStep + 1)">Next</button>
  </div>
</template>

<script>
import { ref, watch, provide, computed } from 'vue'
export default {
  name: 'FormWizard',
  props: {
    onChangeStep: {
      type: Function,
    },
    onComplete: {
      type: Function,
    },
  },
  setup(props) {
    const currentStep = ref(0)

    const numberOfSteps = ref(0)
    provide('STEP_COUNTER', numberOfSteps)
    // Inject the live ref of the current index to child components
    // will be used to toggle each form-step visibility
    provide('CURRENT_STEP', currentStep)

    // Used to have access to titles and beforeChange functions
    const formSteps = ref({})
    provide('FORM_STEPS', formSteps)

    const changeStep = (step) => {
      if (step < 0 || step >= numberOfSteps.value || step === currentStep.value) {
        return
      }
      if (step < currentStep.value) {
        currentStep.value = step
      } else {
        const validateFunc = formSteps.value[currentStep.value].beforeChange
        const valid = validateFunc ? validateFunc() : true
        if (valid) {
          currentStep.value = step
        }
      }
    }

    const onComplete = () => {
      const validateFunc = formSteps.value[currentStep.value].beforeChange
      const valid = validateFunc ? validateFunc() : true
      if (valid) {
        props.onComplete && props.onComplete()
      }
    }

    watch(currentStep, (newValue) => {
      props.onChangeStep && props.onChangeStep(newValue)
    })

    const formStepsAsList = computed(() => (formSteps.value ? Object.values(formSteps.value) : []))

    watch(currentStep, (newValue) => {
      if (!formSteps.value[newValue].checked) {
        formSteps.value[newValue].checked = true
      }
    })

    return {
      currentStep,
      numberOfSteps,
      formSteps: formStepsAsList,
      changeStep,
      // eslint-disable-next-line vue/no-dupe-keys
      onComplete,
    }
  },
}
</script>

<style scoped>
.wizard-header ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-around;
}

.wizard-header li {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  color: #6f6f6f;
  font-size: 20px;
  text-align: center;
}

.wizard-header .circle-number {
  border-radius: 50%;
  background: #6f6f6f;
  color: #000;
  font-size: 30px;
  line-height: 37px;
  width: 40px;
  height: 40px;
  text-align: center;
  z-index: 2;
  margin-bottom: 8px;
}

@media (max-width: 500px) {
  .wizard-header li {
    font-size: 16px;
  }
}

.wizard-header .circle-number.checked {
  background: #fff;
  color: #d80077;
  border: 2px solid #d80077;
}

.wizard-header .circle-number.active {
  background: #d80077;
  color: #fff;
}

.wizard-header li.checked {
  cursor: pointer;
}

.wizard-header li.active {
  color: #d80077;
}

.wizard-header .progress-bar {
  height: 6px;
  background: #d80077;
  position: relative;
  top: 22px;
}

.wizard-step-button-container {
  display: flex;
  justify-content: space-between;
}

.wizard-step-button {
  width: 140px;
  font-size: 16px;
  margin-top: 18px;
  margin-right: 18px;
  text-align: center;
  display: inline-block;
}

.wizard-step-button.next {
  background: #d80077;
  color: #fff;
}
</style>
